import React from 'react';

import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

import useFlowchartConfigAutosaveManager from './useFlowchartConfigAutosaveManager';

/**
 * This component owns the lifecycle for the autosave manager. If the autosave manager hasn't loaded -- which
 * means this component is mounting while a previous save is still in flight -- we wait to render the children.
 */
export function FlowchartConfigAutosaveManager(props: {
  flowchartConfigId: string;
  friendlyName: string;
  children: JSX.Element;
}): JSX.Element {
  const hasAutosaveManagerLoaded = useFlowchartConfigAutosaveManager(
    props.flowchartConfigId,
    props.friendlyName
  );
  return hasAutosaveManagerLoaded ? props.children : <CenteredHorizontalThrobber />;
}
